import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/styleGuard'; // Early runtime style integrity check
import './utils/debugStyles'; // Conditional diagnostics (?debugStyles=1)
import './index.css';
// Theme imports removed - will be loaded conditionally only for authenticated users
import App from './App';
// Dev debug utilities (no-op in production unless flags set)
import devDebug from './utils/devDebug';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { PreferencesProvider } from './contexts/PreferencesContext';
// Debug Stripe key resolution in dev
if (process.env.NODE_ENV === 'development') {
  const runtimeKey = typeof window !== 'undefined' ? window.__STRIPE_PUBLISHABLE_KEY__ : undefined;
  const buildKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  // If runtime key is a known placeholder but build key is real, promote build key to window before app render.
  if (buildKey && (!runtimeKey || /pk_test_PLACEHOLDER|pk_test_12345/.test(runtimeKey))) {
    window.__STRIPE_PUBLISHABLE_KEY__ = buildKey;
  }
  // eslint-disable-next-line no-console
  console.log('[Startup] Stripe key (runtime after override):', window.__STRIPE_PUBLISHABLE_KEY__);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SubscriptionProvider>
        <PreferencesProvider>
            <App />
        </PreferencesProvider>
      </SubscriptionProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Dev: optionally clear service workers/caches or log tutorial state when the
// page loads. Use the browser console to toggle these flags before reload:
//   window.__DEV_CLEAR_SW__ = true
//   window.__DEV_LOG_TUTORIAL_STATE__ = true
try {
  if (typeof window !== 'undefined') {
    if (window.__DEV_LOG_TUTORIAL_STATE__ === true) {
      try { devDebug.logTutorialStorageState(); } catch (e) { /* ignore */ }
    }
    if (window.__DEV_CLEAR_SW__ === true) {
      // Clear asynchronously, then reload to pick up fresh assets
      devDebug.clearServiceWorkersAndCaches().then(() => {
        console.log('[devDebug] clear complete; reloading page');
        window.location.reload(true);
      }).catch(err => console.warn('[devDebug] clear failed', err));
    }
  }
} catch (e) {
  // ignore
}
